const env = (window as any).env || {};

const configValue = (key: string, fallback?: string): string => {
  const value = env[key] || process.env[`REACT_APP_${key}`];

  return !value || value === 'off' ? fallback : value;
};

export const config = {
  RENDERER_URL: configValue('RENDERER_URL'),
  HOWTO_LINK: configValue('HOWTO_LINK'),
  LOADER_IMG_URL: configValue('LOADER_IMG_URL'),
};
